import { date, object, string } from 'yup';

export type PauseBillingFields = {
  startDate: Date | null;
  endDate: Date | null;
  reasonCode: string | null;
  comment: null | string;
  reference: null | string;
};

export const initialValues: PauseBillingFields = {
  startDate: null,
  endDate: null,
  reasonCode: '',
  comment: null,
  reference: null
};

export const validationSchema = object().shape({
  reasonCode: string()
    .nullable()
    .notRequired(),

  startDate: date()
    .min(new Date(new Date().setHours(0, 0, 0, 0)), 'Date cannot be in the past')
    .nullable(),

  endDate: date()
    .min(new Date(new Date().setHours(0, 0, 0, 0)), 'Date cannot be in the past')
    .test('not-before-start', 'End date cannot be earlier than start date', function (value) {
      if(!value || !this.parent.startDate) {
        return true;
      }
      const startDate = new Date(this.parent.startDate);
      const endDate = new Date(value);

      return endDate >= startDate;
    })
    .test('not-same-as-start', 'End date cannot be the same as start date', function (value) {
      const { startDate } = this.parent;
      if (!value || !startDate) return true;
      
      const startDateStr = new Date(startDate).toDateString();
      const endDateStr = new Date(value).toDateString();
      
      return startDateStr !== endDateStr;
    })
    .nullable()
    .required(),

  comment: string()
    .max(100, 'Must be maximum 100 characters')
    .nullable(),

  reference: string()
    .max(50, 'Must be maximum 50 characters')
    .nullable(),
});

